const getInitialFavorites = () => {
  const storedFavorites = localStorage.getItem("favorites");
  return storedFavorites ? JSON.parse(storedFavorites) : [];
};

const handleFavorites = (state = getInitialFavorites(), action) => {
  let updatedFavorites;
  switch (action.type) {
    case "ADD_FAVORITE":
      // Check if the product is already in favorites
      const existingFavorite = state.find(
        (item) => item.id === action.payload
      );
      
      if (existingFavorite) {
        // If already in favorites, return current state
        return state;
      }
      
      // Add new favorite
      updatedFavorites = [...state, { id: action.payload }];
      localStorage.setItem("favorites", JSON.stringify(updatedFavorites));
      return updatedFavorites;

    case "REMOVE_FAVORITE":
      // Remove item from favorites
      updatedFavorites = state.filter(
        (item) => item.id !== action.payload
      );
      localStorage.setItem("favorites", JSON.stringify(updatedFavorites));
      return updatedFavorites;

    case "CLEAR_FAVORITES":
      // Clear all favorites
      localStorage.removeItem("favorites");
      return [];

    default:
      return state;
  }
};

export default handleFavorites;